import { createSlice } from '@reduxjs/toolkit'

import { baseModelState, updateExtraReducers, openForm, closeForm } from 'store/common'
import api from './api'


const initialState = {
  ...baseModelState,
}


export const rpsTariff = createSlice({
  name: 'rpsTariff',
  initialState,
  reducers: {
    openForm,
    closeForm,
  },
  extraReducers: (builder) => {
    updateExtraReducers(builder, api.endpoints.updateRPSTariff);
  },
});

export default rpsTariff.reducer;

export const RPSTariffActions = rpsTariff.actions;
